import React from 'react'

import { PlusCircle as PlusCircleIcon } from 'react-feather'
import { Skeleton } from '@material-ui/lab'
import {
  Container,
  Button,
  Box,
  Grid,
  TablePagination,
  useMediaQuery,
  Card,
} from '@material-ui/core'
import { useParams, useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import {
  Page,
  ContentHeader,
  Permitted,
  PaperHeader,
  FilterButton,
} from 'components'
import theme from 'theme'
import { routes } from 'Routes'

import { CommitteeUsersTable, FilterCommitteeUser } from './components'

import * as service from 'service'
import constants from 'constants/index'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'
import useFilter from 'hooks/useFilter'
import useStyles from './styles'

const CommitteesShow = () => {
  const params = useParams()
  const classes = useStyles()
  const history = useHistory()
  const filter = useFilter()

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response: committeeResponse } = useFetch(
    service.dponet.committees.get,
    {
      committeeId: params.committeeId,
    },
  )

  const committee = committeeResponse?.data?.committee

  const {
    response: committeeUsersResponse,
    isLoading: isCommitteeUsersLoading,
    refresh: refreshCommitteeUsers,
  } = useFetch(
    service.dponet.committeeUsers.get,
    {
      committeeId: params.committeeId,
      perPage,
      page,
      ...filter.filters,
    },
    [page, perPage, filter.filters],
  )

  const committeeUsers = committeeUsersResponse?.data?.committeeUsers

  const navigateTo = (committeeId) => {
    history.push(reverse(routes.committees.committeeUserNew, { committeeId }))
  }

  return (
    <Page title="Usuários do comitê">
      <Container maxWidth={false} className={classes.container}>
        <ContentHeader title={committee?.name}>
          <Permitted tag={constants.permissions.COMMITTEES.MANAGE}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={() => navigateTo(committee?.id)}
              fullWidth
            >
              CADASTRAR MEMBRO
            </Button>
          </Permitted>
          <FilterButton setDrawerOpen={filter.setDrawerOpen}></FilterButton>
        </ContentHeader>

        <Card>
          <PaperHeader title="Membros" />
          <Box
            m={2}
            border={`1px solid ${theme.palette.paper.border}`}
            borderRadius="4px"
          >
            <Box width="100%" mt={2}>
              <Grid container>
                <CommitteeUsersTable
                  committeeUsers={committeeUsersResponse && committeeUsers}
                  isLoading={isCommitteeUsersLoading}
                  onEvent={refreshCommitteeUsers}
                />
              </Grid>
            </Box>

            <Box px={2} display="flex" justifyContent="flex-end">
              {!isCommitteeUsersLoading && committeeUsersResponse ? (
                <TablePagination
                  component="div"
                  count={committeeUsersResponse?.data?.meta?.totalCount}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  page={page - 1}
                  rowsPerPage={perPage}
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  labelRowsPerPage={isDesktop ? 'Por página' : ''}
                  nextIconButtonProps={{ size: 'small' }}
                  backIconButtonProps={{ size: 'small' }}
                />
              ) : (
                <Box py="11px">
                  <Skeleton variant="rect" width={200} height={30} />
                </Box>
              )}
            </Box>
          </Box>
        </Card>
      </Container>
      <FilterCommitteeUser filter={filter} />
    </Page>
  )
}

export default CommitteesShow
